var url_path = window.location.pathname;

if (url_path == '/products' || url_path == '/products/'){
  window.location.href = "/collections/all";
}

function addToCartEventFB(){
  if (typeof fbq === 'function') fbq('track', 'AddToCart');
}

$(window).on('load', function() {

    // -------- Klavyio form submit + FB lead
    window.addEventListener("klaviyoForms", function(e) { 
        if (e.detail.type == 'submit' && typeof fbq === 'function') {
            fbq('track', 'Lead');
        }
    });


    /* ---- prefix PageFly links with the active Shopify locale ---- */
    var localeMatch = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?=\/|$)/);
    if (localeMatch) {
        var locale = localeMatch[1];

        // add/remove segments here as needed
        var segments = ['products', 'pages', 'collections'];
        var segRe = segments.join('|');

        $('a[href*="/"]').filter(function () {
            return new RegExp('/(' + segRe + ')/').test($(this).attr('href') || '');
            
        }).each(function () {
            var href = $(this).attr('href');
            // skip if already localized

            if (new RegExp('^(https?:\\/\\/[^\\/]+)?\\/' + locale + '\\/').test(href)) return;

            $(this).attr('href', href.replace(
                new RegExp('(^(?:https?:\\/\\/[^\\/]+)?)\\/(' + segRe + ')\\/'),
                '$1/' + locale + '/$2/'
            ));
        });
    }



});